import { createStyles, List, ListItem, ListItemText, makeStyles, Theme, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Accordion, AccordionDetails, AccordionSummary } from '../../../../../../components/accordion/accordion.styled';
import { MessagingNodeData, MessagingNodeRefreshInterval } from '../flow';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {
      width: '100%',
      paddingTop: 0,
      paddingBottom: 0,
    },
    listStriped: {
      '& li:nth-child(odd)': {
        backgroundColor: '#f2f2f2'
      }
    },
    itemKey: { width: '45%' },
    itemValue: {
      width: '55%',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      paddingLeft: theme.spacing(1)
    }
  })
);

export function StatusPanel(props: {
  data: MessagingNodeData,
  autoRefresh?: boolean,
  expanded: string | boolean,
  onAccordionStateChange: (panel: any) => (_event: ChangeEvent<{}>, isExpanded: boolean) => void,
}) {

  const { data, autoRefresh, expanded, onAccordionStateChange } = props;
  
  const classes = useStyles();

  const [tableData, setTableData] = useState<[string, string | number | undefined][]>([] as [string, string | number | undefined][]);

  const refresh = useCallback(() => data.stats().then((stats: Record<string, string | number>) =>
    Object.entries(stats.info).filter(([_, item]) => item !== undefined)
  ), [data]);

  useEffect(() => {
    refresh().then(setTableData);
    if (autoRefresh) {
      const interval = setInterval(() => refresh().then(setTableData), MessagingNodeRefreshInterval);
      return () => clearInterval(interval);
    }
    return undefined;
  }, [autoRefresh, data, refresh]);

  return (<Accordion expanded={expanded === 'status'} onChange={onAccordionStateChange('status')}>
    <AccordionSummary expandIcon={<ExpandMoreIcon />}>Status</AccordionSummary>
    <AccordionDetails>
      {tableData.length > 0 ? (<>
        <List dense className={`${classes.list} ${classes.listStriped}`} >
          {tableData.map(([key, item], index: number) =>(
              <ListItem key={index}>
                <ListItemText className={classes.itemKey} primary={key}/>
                <ListItemText className={classes.itemValue} secondary={item}/>
              </ListItem>
            ))}
        </List>
      </>) : (
        <Typography variant='caption' component="p">Loading status to show.</Typography>
      )}
    </AccordionDetails>
  </Accordion>);
}